import CityList from './CityList';

export default CityList;
